/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ company: NonNullable<unknown> }} Dashboard_At_CompanyInputs */

const en_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`at ${i?.company}`)
};

const de_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`bei ${i?.company}`)
};

const fr_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`chez ${i?.company}`)
};

const es_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`en ${i?.company}`)
};

const it_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`presso ${i?.company}`)
};

const nl_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`bij ${i?.company}`)
};

const pl_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`w ${i?.company}`)
};

const fi_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`yrityksessä ${i?.company}`)
};

const da_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`hos ${i?.company}`)
};

const sv_dashboard_at_company = /** @type {(inputs: Dashboard_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`på ${i?.company}`)
};

/**
* | output |
* | --- |
* | "at {company}" |
*
* @param {Dashboard_At_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_at_company = /** @type {((inputs: Dashboard_At_CompanyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_At_CompanyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_at_company(inputs)
	if (locale === "fr") return fr_dashboard_at_company(inputs)
	if (locale === "es") return es_dashboard_at_company(inputs)
	if (locale === "it") return it_dashboard_at_company(inputs)
	if (locale === "nl") return nl_dashboard_at_company(inputs)
	if (locale === "pl") return pl_dashboard_at_company(inputs)
	if (locale === "fi") return fi_dashboard_at_company(inputs)
	if (locale === "da") return da_dashboard_at_company(inputs)
	if (locale === "sv") return sv_dashboard_at_company(inputs)
	return en_dashboard_at_company(inputs)
});